import React, { useState } from "react";
import Game from "./components/Game";
import { DEFAULT_GAMES, CURRENT_GAME_KEY } from "./constants/constants";
import TextCell from "./components/gridCells/TextCell";
import { AlertCenter } from "./classes/AlertCenter";
import { getCurrentGame } from "./utils";

export default () => {
  const [, updateState] = React.useState<object>();
  const triggerRender = React.useCallback(() => updateState({}), []);
  const [alertCenter] = useState(() => new AlertCenter(triggerRender));
  const [game, setGame] = useState<string>(getCurrentGame());

  const setGameAndReset = (newGame: string) => {
    if (newGame !== game) {
      localStorage.setItem(CURRENT_GAME_KEY, newGame);
      setGame(newGame);
    }
  };

  const games = Object.keys(DEFAULT_GAMES).map((key: any) => {
    return (
      <option value={key} key={`game-${key}`}>
        {key}
      </option>
    );
  });

  return (
    <div>
      <div className="grid-container grid-data-table grid-game-options">
        <TextCell dataTest="select-game-label" text="Select Game" />
        <select
          value={game}
          className="textCell inline-select inline-select-background"
          onChange={(event) => setGameAndReset(event.target.value)}
        >
          {games}
        </select>
      </div>
      <Game key={game} game={game} alertCenter={alertCenter} />
    </div>
  );
};
